<template>
  <FormKit
    type="form"
    name="Kontakt-B2C"
    id="Kontakt-B2C"
    :incomplete-message="false"
    :actions="false"
    @submit="submitContactFlinkster"
    #default="{ state: { valid } }"
    form-class="dbc-formkit-form"
  >
    <div class="dbc-formkit-form-inner">
      <div>
        <FormKit
          type="dbcText"
          name="name"
          :label="$t('dbc-contact-b2c-input-name-label')"
          :placeholder="$t('dbc-contact-b2c-input-name-placeholder')"
          validation="required"
        />
        <FormKit
          type="dbcEmail"
          name="mail"
          :label="$t('dbc-contact-b2c-input-email-label')"
          validation="required|email"
          :validation-messages="{
            email: $t('dbc-error-email-validation'),
          }"
          :placeholder="$t('dbc-contact-b2c-input-email-placeholder')"
        />
        <FormKit
          type="select"
          :label="$t('dbc-contact-b2c-select-topic-label')"
          :placeholder="`- ${$t('dbc-contact-b2c-select-topic-placeholder')} -`"
          validation="required"
          name="topic"
          :options="topicOptions"
        />
      </div>
      <div>
        <FormKit
          type="textarea"
          name="message"
          :label="$t('dbc-contact-b2c-textarea-message-label')"
          rows="10"
          validation="required"
          :placeholder="$t('dbc-contact-b2c-textarea-message-placeholder')"
        />
      </div>
    </div>

    <FormsOmqContainer />

    <FormKit
      type="submit"
      :label="$t('dbc-contact-button-submit')"
      :disabled="!valid"
      input-class="!w-[128px]"
    />
  </FormKit>
</template>

<script setup lang="ts">
const emit = defineEmits<{
  (e: 'onSubmitContactZnuny', formData: ContactFormData): void
}>()

function submitContactFlinkster(formData: ContactFormData) {
  emit('onSubmitContactZnuny', formData)
}

const { t } = useI18n()

const topicOptions = ref([
  `${t('dbc-contact-b2c-select-topic-option-complaint')}`,
  `${t('dbc-contact-b2c-select-topic-option-tariff-change')}`,
  `${t('dbc-contact-b2c-select-topic-option-request')}`,
  `${t('dbc-contact-b2c-select-topic-option-technical-defect')}`,
  `${t('dbc-contact-b2c-select-topic-option-sponsoring')}`,
  `${t('dbc-contact-b2c-select-topic-option-other')}`,
])
</script>
